import React, { useState, useEffect } from "react";
import SecondaryMenu from "../shared/SecondaryMenu";
import {
  Grid,
  makeStyles,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableBody,
  TextField,
  Button,
} from "@material-ui/core";
import api from "../../store/api";
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: 40,
    paddingRight: 40,
  },
  heading: {
    fontSize: 36,
    padding: theme.spacing(5, 0, 5, 0),
    fontWeight: 900,
  },
  subheading: {
    fontSize: 16,
    fontWeight: "bold",
  },
  tableCellTitle: {
    width: "80%",
    fontWeight: "bold",
    padding: 8,
  },
  tableCellValue: {
    width: "10%",
    fontWeight: "bold",
    padding: 8,
  },
  info: {
    fontSize: 14,
  },
  btnContainer: {
    display: "flex",
    marginBottom: 40,
    paddingLeft: 40,
  },
  btn: {
    marginLeft: 15,
    padding: 5,
  },
  divider: {
    margin: "40px 0",
    borderTop: "1px solid #acacac",
  },
  headingAlert: {
      padding: theme.spacing(0, 0, 2, 0),
  },
  alertRoot: {
      marginTop: 24
  },
}));

const GlobalSettingsWidget = () => {
  const classes = useStyles();
  const [globalSettngs, setGlobalSettings] = useState<any>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");

  const getGlobalSettings = async () => {
    const res = await api.getGlobalSettings("");
    setGlobalSettings({
      defaultAmbulantPickupDuration: res.model.defaultAmbulantPickupDuration,
      defaultAmbulantDropoffDuration: res.model.defaultAmbulantDropoffDuration,
      defaultNonAmbulantPickupDuration:
        res.model.defaultNonAmbulantPickupDuration,
      defaultNonAmbulantDropoffDuration:
        res.model.defaultNonAmbulantDropoffDuration,
      minimumSamplesBeforeUsingStats: res.model.minimumSamplesBeforeUsingStats,
      additionalPickupAllowance: res.model.additionalPickupAllowance,
      additionalDropoffAllowance: res.model.additionalDropoffAllowance,
      drivingTimeRangeModifier: res.model.drivingTimeRangeModifier,
      overralDrivingTimeRangeModifier:
        res.model.overralDrivingTimeRangeModifier,
      maximumSamplesForMedianCalculation:
        res.model.maximumSamplesForMedianCalculation,
      numberOfDaysForMedianCalculation:
        res.model.numberOfDaysForMedianCalculation,
    });
  };

  useEffect(() => {
    getGlobalSettings();
  }, []);

  const saveGlobalSettings = () => {
    const data = globalSettngs;
    api.setGlobalSettings("", data).then((res: any) => {
      if(res.hasError) {
        setErrorMessage(res.message);
        setStatusMessage("");
      } else {
        setStatusMessage(res.message);
        setErrorMessage("");
        setTimeout(() => {
          setStatusMessage("");
        }, 6000)
      }
    });
  };

  return (
    <React.Fragment>
      <div style={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
        <div style={{ alignSelf: "stretch", display: "flex" }}>
          <SecondaryMenu selectedmenu="Global Settings" />
        </div>

        <div>
          <Grid container className={classes.container}>
            <Grid item xs={12}>
              <div className={classes.heading}>Global Settings</div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.subheading}>TRIP ESTIMATOR SETTINGS</div>
              <div
                className={classes.divider}
                style={{ marginBottom: 0, marginTop: 20 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TableContainer style={{ overflowX: "initial" }}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        Default ambulant pickup duration (minutes)
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.defaultAmbulantPickupDuration}
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              defaultAmbulantPickupDuration: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        Default ambulant dropoff duration (minutes)
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.defaultAmbulantDropoffDuration}
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              defaultAmbulantDropoffDuration: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        Default non-ambulant pickup duration (minutes)
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={
                            globalSettngs?.defaultNonAmbulantPickupDuration
                          }
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              defaultNonAmbulantPickupDuration: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        Default non-ambulant dropoff duration (minutes)
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={
                            globalSettngs?.defaultNonAmbulantDropoffDuration
                          }
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              defaultNonAmbulantDropoffDuration: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        <div>
                          Minimum samples before pickup/dropoff statistics are used
                        </div>
                        <div className={classes.info}>
                          Makes pickup/dropoff delays more accurate by waiting till we have enough data before using it. The defaults above are used in the meantime.
                        </div>
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.minimumSamplesBeforeUsingStats}
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              minimumSamplesBeforeUsingStats: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow><TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        Maximum Number of sample to use for median calculation
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={
                            globalSettngs?.maximumSamplesForMedianCalculation
                          }
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              maximumSamplesForMedianCalculation: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        <div>Additional pickup allowance (minutes) </div>
                        <div className={classes.info}>
                          Added to pickup delay when estimating. Use to
                          temporarilly cater for change in procedures
                        </div>
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.additionalPickupAllowance}
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              additionalPickupAllowance: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        <div>Additional dropoff allowance (minutes) </div>
                        <div className={classes.info}>
                          Added to dropoff delay when estimating. Use to
                          temporarilly cater for change in procedures
                        </div>
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.additionalDropoffAllowance}
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              additionalDropoffAllowance: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        <div>
                          Driving time range modifier (0% = lowest estimate,
                          100% = highest estimate)
                        </div>
                        <div className={classes.info}>
                          Take the best-case estimate, the worst-case estimate,
                          or somewhere in between. Applies to time-of-day
                          estimates only, not real-time driving time calculation
                        </div>
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.drivingTimeRangeModifier}
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              drivingTimeRangeModifier: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        <div>
                          Overall driving time modifier (% of calculated driving
                          time to use){" "}
                        </div>
                        <div className={classes.info}>
                          Are driving time estimates consistency too short or
                          too long? Adjust them here. Applies to time-of-day
                          estimates as we'll as real-time estimates{" "}
                        </div>
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={globalSettngs?.overralDrivingTimeRangeModifier}
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              overralDrivingTimeRangeModifier: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellTitle}>
                        Number of days for median of calculation
                      </TableCell>
                      <TableCell className={classes.tableCellValue}>
                        <TextField
                          value={
                            globalSettngs?.numberOfDaysForMedianCalculation
                          }
                          variant="outlined"
                          type="number"
                          onChange={(e) =>
                            setGlobalSettings({
                              ...globalSettngs,
                              numberOfDaysForMedianCalculation: parseInt(
                                e.target.value
                              ),
                            })
                          }
                        />
                      </TableCell>
                    </TableRow>
                    
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          <div style={{ paddingLeft: 40, paddingRight: 40, }}>
              <div className={classes.headingAlert}>
                  <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                      {errorMessage}
                  </Alert>
                  <Alert variant="filled" severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? 'flex' : 'none' }}>
                      {statusMessage}
                  </Alert>
              </div>
          </div>
          <div className={classes.divider} />
          <div className={classes.btnContainer}>
            <Button
              className={classes.btn}
              variant="contained"
              color="primary"
              onClick={saveGlobalSettings}
            >
              Save
            </Button>
            <Button className={classes.btn} variant="contained">
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GlobalSettingsWidget;
